module.exports = __webpack_public_path__ + "img/25_8.cbc4c699.png";